var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Filter useForm props from a component to avoid React warnings for invalid props.
 */
export var filterUseFormProps = function (props) {
    var fieldState = props.fieldState, resetFieldState = props.resetFieldState, updateFieldState = props.updateFieldState, isValid = props.isValid, hasError = props.hasError, isInitial = props.isInitial, validate = props.validate, filteredProps = __rest(props, ["fieldState", "resetFieldState", "updateFieldState", "isValid", "hasError", "isInitial", "validate"]);
    return filteredProps;
};
